



























import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Watch, Ref, Emit } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";

@Component({
    directives: {
        ClickOutside
    },
    components: {
        ValidationProvider
    }
})
export default class FormSelect extends Vue {
    @Prop({ default: "Maak een keuze" }) name?: string;

    @Prop({ default: "Maak een keuze" }) readonly placeholder!: string;

    @Prop({ default: "" }) readonly value!: string[];

    @Prop() label?: string;

    @Prop({ default: () => [] }) readonly options!: string[];

    @Prop({ default: true }) showError?: boolean;

    @Prop({ default: false }) readonly multiple!: boolean;

    @Prop({ default: false }) readonly required!: boolean;

    @Prop() rules?: string | object;

    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    isFocussed = false;

    localValue: string[] = [];

    validAtleastOnce = false;

    private get formValdiated(): boolean {
        return this.provider.$_veeObserver?.flags?.validated;
    }

    private get validateAs(): string {
        if (this.label) {
            return this.label;
        }

        if (this.placeholder) {
            return this.placeholder;
        }

        if (this.name) {
            return this.name;
        }

        return `select field`;
    }

    private eagerIfDirty(_a: { flags: any; errors: any }) {
        var errors = _a.errors;
        var flags = _a.flags;
        if (errors.length) {
            return {
                on: ["input", "change"]
            };
        }

        if (flags.valid && !this.validAtleastOnce) {
            this.validAtleastOnce = true;
        }

        if (flags.dirty) {
            return {
                on: ["change", "blur", "input"]
            };
        }

        return {
            on: ["change"]
        };
    }

    @Emit("blur")
    private handleBlur(e: Event): Event {
        if (this.provider && this.provider.flags.dirty) {
            this.validAtleastOnce = true;
        }
        this.isFocussed = false;
        return e;
    }

    @Emit("focus")
    private handleFocus(e: Event): Event {
        this.isFocussed = true;
        return e;
    }

    @Emit("input")
    private handleInput() {
        return this.localValue;
    }

    @Watch("value", { immediate: true })
    handleValueChange(value: string[]) {
        this.localValue = Array.isArray(value) ? value : [];
    }

    @Watch("localValue")
    handleLocalValueChange(value: string[]) {
        this.$emit("input", value);
    }
}
